import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { IChangesHistory } from 'app/shared/interfaces';
import { ChangesHistoryFacade } from 'app/store/facades/changes-history.facade';

@Component({
  standalone: false,
  selector: 'app-changes-history',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-changes-history-dumb
    [history]="history$ | async"
    [loading]="loading$ | async"
    ></app-changes-history-dumb>`,
})
export class ChangesHistoryContainer {

  history$: Observable<IChangesHistory[]>;
  loading$: Observable<boolean>;

  constructor(
    private readonly changesHistoryFacade: ChangesHistoryFacade,
  ) {
    this.history$ = changesHistoryFacade.history$;
    this.loading$ = changesHistoryFacade.loading$;
  }

}
